import { PluginInterface } from './PluginInterface';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';
import { errorAction } from '../extensions';
import { normalizeErrors } from '../../handlers/error';
import { CAST_MESSAGES } from '../../config/receiver';

export class ErrorsToSenderPlugin implements PluginInterface {
  init(context: CastReceiverContext) {
    errorAction.register(e => {
      const normalizedErrors = normalizeErrors(e);
      for (const error of normalizedErrors) {
        for (const sender of context.getSenders()) {
          context?.sendCustomMessage(CAST_MESSAGES.ERROR, sender.id, error);
        }
      }
    });
  }
}
